import { Action } from 'redux'
import * as Actions from './actionTypes'
import { buildErrorAction, ErrorAction } from 'src/common/apiLoader/state/actions'
import { CashboxCategoriesFilters, CashboxCategory } from 'src/common/models/cashboxCategory'
import { IncomeRecord, IncomeRecordsFilters } from 'src/common/models/incomeRecord'

export interface GetCashboxCategoriesAction extends Action {
    filters?: CashboxCategoriesFilters
}
export interface GetCashboxCategoriesSuccessAction extends Action {
    cashboxCategories: CashboxCategory[]
}
export const getCashboxCategoriesApi = (filters?: CashboxCategoriesFilters): GetCashboxCategoriesAction => ({
    type: Actions.GET_CASHBOX_CATEGORIES_API,
    filters,
})
export const getCashboxCategoriesApiSuccess = (cashboxCategories: CashboxCategory[]): GetCashboxCategoriesSuccessAction => ({
    type: Actions.GET_CASHBOX_CATEGORIES_API_SUCCESS,
    cashboxCategories,
})
export const getCashboxCategoriesApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_CASHBOX_CATEGORIES_API_ERROR,
    error,
)

export interface UpsertCashboxCategoryAction extends Action {
    cashboxCategory: CashboxCategory
}
export interface UpsertCashboxCategorySuccessAction extends Action {
    cashboxCategory: CashboxCategory
}
export const upsertCashboxCategoryApi = (cashboxCategory: CashboxCategory): UpsertCashboxCategoryAction => ({
    type: Actions.UPSERT_CASHBOX_CATEGORY_API,
    cashboxCategory,
})
export const upsertCashboxCategoryApiSuccess = (cashboxCategory: CashboxCategory): UpsertCashboxCategorySuccessAction => ({
    type: Actions.UPSERT_CASHBOX_CATEGORY_API_SUCCESS,
    cashboxCategory,
})
export const upsertCashboxCategoryApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.UPSERT_CASHBOX_CATEGORY_API_ERROR,
    error,
)

export interface CreateIncomeRecordAction extends Action {
    incomeRecord: IncomeRecord
}
export interface CreateIncomeRecordSuccessAction extends Action {
    incomeRecord: IncomeRecord
}
export const createIncomeRecordApi = (incomeRecord: IncomeRecord): CreateIncomeRecordAction => ({
    type: Actions.CREATE_INCOME_RECORD_API,
    incomeRecord,
})
export const createIncomeRecordApiSuccess = (incomeRecord: IncomeRecord): CreateIncomeRecordSuccessAction => ({
    type: Actions.CREATE_INCOME_RECORD_API_SUCCESS,
    incomeRecord,
})
export const createIncomeRecordApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.CREATE_INCOME_RECORD_API_ERROR,
    error,
)

export interface GetIncomeRecordsAction extends Action {
    filters?: IncomeRecordsFilters
}
export interface GetIncomeRecordsSuccessAction extends Action {
    incomeRecords: IncomeRecord[]
}
export const getIncomeRecordsApi = (filters?: IncomeRecordsFilters): GetIncomeRecordsAction => ({
    type: Actions.GET_INCOME_RECORDS_API,
    filters,
})
export const getIncomeRecordsApiSuccess = (incomeRecords: IncomeRecord[]): GetIncomeRecordsSuccessAction => ({
    type: Actions.GET_INCOME_RECORDS_API_SUCCESS,
    incomeRecords,
})
export const getIncomeRecordsApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_INCOME_RECORDS_API_ERROR,
    error,
)